import React from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const App: React.FC = () => {
  return (
    <AppContainer>
      <Header />
      <Hero />
      <About />
      <Services />
      <Products />
      <Gallery />
      <Contact />
      <Footer />
    </AppContainer>
  );
};

export default App; 